export default {
    name: 'normative',
    serverName: '/api/v1/normative_calculator/calculation/',
    apiUrl: '/api/v1/normative_calculator/calculation/'
};
